import { render, staticRenderFns } from "./CaseSelectedDisplay.vue?vue&type=template&id=8f85f3a2&scoped=true&"
import script from "./CaseSelectedDisplay.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaseSelectedDisplay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f85f3a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
